import {graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

/**
 * Per-task client sign-off config from the Scoping table columns. Proxies through
 * graphql/ to the client workspace's internal admin API.
 *
 * The task NODE is selected for the same reason as the phase write: without an id the
 * saved value cannot be merged into the task record the table is rendering, so the
 * approver picker on an overridden row visually reverts to its previous value.
 */
const mutation = graphql`
	mutation updateTaskPortalConfigMutation($input: UpdateTaskPortalConfigInput!) {
		updateTaskPortalConfig(input: $input) {
			task {
				id
				portalConfig {
					requiresClientSignoff
					signoffApproverPortalUserId
				}
			}
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return trackAndCommitMutation(environment, {mutation, variables, onCompleted: onSuccess, onError}, true);
}

export default {commit};
